export default "__VITE_ASSET__c8753f20__"